import { addMessages } from '@hana/i18n';

// Chuỗi giao diện AI đọc chứng từ. Mã booking, tên tàu, nhãn ô dữ liệu mẫu không dịch.
addMessages('vi', {
  'airead.noWrite': 'Chưa mở ghi ở bản này',
  'ar.aMatch': 'Khớp',
  'ar.aDiff': 'Lấy giá trị file (Alt+→)',
  'ar.aEmpty': 'Chép từ file (Alt+→)',
  'ar.aLock': 'Khoá nhận diện · không chép',
  'ar.aHand': 'Chỉ nhập tay',
  'ar.viewOnly': 'Chỉ xem.',
  'ar.noEmptyFill': 'Không còn ô trống chép được',
  'ar.copied': 'Đã chép {n} ô từ file',
  'ar.confirmedHigh': 'Đã xác nhận ô tin cậy cao',
  'ar.lookLeft': 'Còn {n} ô cần xem',
  'ar.customer': 'Khách hàng',
  'ar.route': 'Tuyến',
  'ar.carrier': 'Hãng tàu',
  'ar.container': 'Container',
  'ar.srcMail': 'Thư nguồn · info@ 21/Oct/2026 10:42',
  'ar.port': 'Cảng · terminal',
  'ar.jobCount': 'Số job',
  'ar.jobN': '{n} job',
  'ar.mSave': 'Lưu + Confirm booking',
  'ar.mSaveVs': 'Lưu + soạn Schedule Notice',
  'ar.mFill': 'Chép {n} ô trống',
  'ar.mConfHigh': 'Xác nhận ô tin cậy cao',
  'ar.mReread': 'Đọc lại tệp',
  'ar.reread': 'Đã đọc lại · {f}',
  'ar.mDiscard': 'Bỏ thay đổi',
  'ar.discarded': 'Đã bỏ {n} thay đổi',
  'ar.mOne': 'Mở 1 form',
  'ar.open1rq': 'Mở RQ SE260639460 · 1 form',
  'ar.open1vs': 'Mở lịch tàu YM CERTAINTY 089N · 1 form',
  'ar.backBooking': 'Về Booking',
  'ar.titleRq': 'AI đọc · SE260639460',
  'ar.titleVs': 'AI đọc · YM CERTAINTY 089N',
  'ar.formTarget': 'Form nhập',
  'ar.tRq': 'RQ booking',
  'ar.tVs': 'Lịch tàu',
  'ar.density': 'Mật độ',
  'ar.dStd': 'Chuẩn',
  'ar.dDense': 'Gọn',
  'ar.save': 'Lưu',
  'ar.moreActions': 'Thêm thao tác',
  'ar.moreActionsPad': 'Thao tác khác',
  'ar.actions': 'Thao tác',
  'ar.emptyT': 'Chưa có tệp để đọc.',
  'ar.upload': 'Tải lên tệp',
  'ar.errT': 'Không đọc được tệp.',
  'ar.reread2': 'Đọc lại',
  'ar.roNote': 'Chỉ xem · không chép và không lưu vào form.',
  'ar.srcFile': 'File gốc',
  'ar.swapFile': 'Đổi tệp',
  'ar.uploaded': 'Đã tải lên · Booking_ARRIVE_scan.jpg · đang đọc',
  'ar.viewMode': 'Cách xem',
  'ar.readable': 'Chữ đọc được',
  'ar.rereadN': 'Đã đọc lại · {f} · {n} ô',
  'ar.expand': 'Mở rộng tệp',
  'ar.download': 'Tải xuống',
  'ar.downloaded': 'Đã tải xuống {f}',
  'ar.zoomOut': 'Thu nhỏ',
  'ar.zoomIn': 'Phóng to',
  'ar.fit': 'Vừa khung',
  'ar.prevPage': 'Trang trước',
  'ar.nextPage': 'Trang sau',
  'ar.pageAria': '{f} · trang {p} / {n}',
  'ar.secRq': 'RQ · SE260639460',
  'ar.secVs': 'Lịch tàu · YM CERTAINTY 089N',
  'ar.fltCell': 'Lọc ô',
  'ar.fAll': 'Tất cả',
  'ar.fLook': 'Cần xem',
  'ar.fDiff': 'Lệch',
  'ar.fEmpty': 'Trống',
  'ar.noneLeft': 'Không còn ô cần xem',
  'ar.impact': 'Ảnh hưởng khi lưu',
  'ar.hand': 'Nhập tay',
  'ar.fileVal': 'file: {v}',
  'ar.undoCopyAria': 'Hoàn tác lần chép (Ctrl+Z)',
  'ar.aiFilled': 'AI điền · Bỏ',
  'ar.removed': 'đã bỏ · Hoàn tác',
  'ar.copiedUndo': 'đã chép · Hoàn tác',
  'ar.confidence': 'Độ tin cậy {c}%',
  'ar.confirmedL': 'Đã xác nhận {l}',
  'ar.confirmL': 'Xác nhận {l}',
});
addMessages('en', {
  'airead.noWrite': 'Writing is not enabled in this version',
  'ar.aMatch': 'Match',
  'ar.aDiff': 'Take file value (Alt+→)',
  'ar.aEmpty': 'Copy from file (Alt+→)',
  'ar.aLock': 'Locked identifier · cannot copy',
  'ar.aHand': 'Manual entry only',
  'ar.viewOnly': 'View only.',
  'ar.noEmptyFill': 'No empty fields left to copy',
  'ar.copied': 'Copied {n} fields from file',
  'ar.confirmedHigh': 'High-confidence fields confirmed',
  'ar.lookLeft': '{n} fields still need review',
  'ar.customer': 'Customer',
  'ar.route': 'Route',
  'ar.carrier': 'Carrier',
  'ar.container': 'Container',
  'ar.srcMail': 'Source email · info@ 21/Oct/2026 10:42',
  'ar.port': 'Port · terminal',
  'ar.jobCount': 'Job count',
  'ar.jobN': '{n} jobs',
  'ar.mSave': 'Save + Confirm booking',
  'ar.mSaveVs': 'Save + draft Schedule Notice',
  'ar.mFill': 'Copy {n} empty fields',
  'ar.mConfHigh': 'Confirm high-confidence fields',
  'ar.mReread': 'Re-read file',
  'ar.reread': 'Re-read · {f}',
  'ar.mDiscard': 'Discard changes',
  'ar.discarded': 'Discarded {n} changes',
  'ar.mOne': 'Open 1 form',
  'ar.open1rq': 'Opened RQ SE260639460 · 1 form',
  'ar.open1vs': 'Opened vessel schedule YM CERTAINTY 089N · 1 form',
  'ar.backBooking': 'Back to Booking',
  'ar.titleRq': 'AI read · SE260639460',
  'ar.titleVs': 'AI read · YM CERTAINTY 089N',
  'ar.formTarget': 'Target form',
  'ar.tRq': 'RQ booking',
  'ar.tVs': 'Vessel schedule',
  'ar.density': 'Density',
  'ar.dStd': 'Standard',
  'ar.dDense': 'Compact',
  'ar.save': 'Save',
  'ar.moreActions': 'More actions',
  'ar.moreActionsPad': 'More actions',
  'ar.actions': 'Actions',
  'ar.emptyT': 'No file to read.',
  'ar.upload': 'Upload file',
  'ar.errT': 'Cannot read the file.',
  'ar.reread2': 'Re-read',
  'ar.roNote': 'View only · cannot copy or save to the form.',
  'ar.srcFile': 'Source file',
  'ar.swapFile': 'Change file',
  'ar.uploaded': 'Uploaded · Booking_ARRIVE_scan.jpg · reading',
  'ar.viewMode': 'View mode',
  'ar.readable': 'Readable text',
  'ar.rereadN': 'Re-read · {f} · {n} fields',
  'ar.expand': 'Expand file',
  'ar.download': 'Download',
  'ar.downloaded': 'Downloaded {f}',
  'ar.zoomOut': 'Zoom out',
  'ar.zoomIn': 'Zoom in',
  'ar.fit': 'Fit to frame',
  'ar.prevPage': 'Previous page',
  'ar.nextPage': 'Next page',
  'ar.pageAria': '{f} · page {p} / {n}',
  'ar.secRq': 'RQ · SE260639460',
  'ar.secVs': 'Vessel schedule · YM CERTAINTY 089N',
  'ar.fltCell': 'Filter fields',
  'ar.fAll': 'All',
  'ar.fLook': 'Needs review',
  'ar.fDiff': 'Mismatch',
  'ar.fEmpty': 'Empty',
  'ar.noneLeft': 'No fields left to review',
  'ar.impact': 'Impact on save',
  'ar.hand': 'Type manually',
  'ar.fileVal': 'file: {v}',
  'ar.undoCopyAria': 'Undo last copy (Ctrl+Z)',
  'ar.aiFilled': 'AI filled · Remove',
  'ar.removed': 'removed · Undo',
  'ar.copiedUndo': 'copied · Undo',
  'ar.confidence': 'Confidence {c}%',
  'ar.confirmedL': 'Confirmed {l}',
  'ar.confirmL': 'Confirm {l}',
});
